import ImageNotFallback from './image-not-fallback';
import ImageWithFallback from './image-with-fallback';

const CustomImageWithFallback = ImageWithFallback;

export { ImageNotFallback as CustomImageNotFallback };

export default CustomImageWithFallback;
